import { render, staticRenderFns } from "./LayoutSubNav.vue?vue&type=template&id=85766224&scoped=true"
import script from "./LayoutSubNav.vue?vue&type=script&lang=js"
export * from "./LayoutSubNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutSubNav.vue?vue&type=style&index=0&id=85766224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85766224",
  null
  
)

export default component.exports